import { useContext } from 'react';
/**
 * Create a state hook
 */
export var createStateHook = function (stateContext) {
    return function () {
        var state = useContext(stateContext);
        if (state === undefined) {
            throw new Error('useState must be used within a Provider');
        }
        return state;
    };
};
//# sourceMappingURL=createStateHook.js.map